import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ViewChild, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import { AlertComponent, ButtonComponent, MbsPopupType, ModalFooterDirective } from 'mbs-ui-kit';
import { ModalComponent } from 'mbs-ui-kit/modal/modal.component';
import { HelpLinkDirective } from 'mbs-ui-shared@help/helpLink.directive';

@UntilDestroy()
@Component({
  selector: 'backup-update-required-modal',
  templateUrl: './backup-update-required-modal.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonComponent,
    HelpLinkDirective,
    NgbTooltipModule,
    AlertComponent,
    I18NextPipe,
    ModalComponent,
    ModalFooterDirective
  ]
})
export class BackupUpdateRequiredModalComponent implements AfterViewInit {
  private cdr = inject(ChangeDetectorRef);

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  public computerName: string;
  public alertType = MbsPopupType.warning;

  ngAfterViewInit(): void {
    if (this.baseModal.data) {
      this.computerName = this.baseModal.data.computerName;
      this.cdr.detectChanges();
    }
  }
}
